// eslint-disable-next-line import/prefer-default-export
export const STYLE_VARIANTS = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;
